module.exports = __webpack_public_path__ + "img/business-plan.2a14fee3.png";